import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import { ADD_WEBINAR_PARTICIPANT, FETCH_SETTINGS } from "../../api/apiList";
import API from "../../api";
import "./styles-w.scss";
import { Modal } from "reactstrap";
import { handleError, notify } from "../../utils";
import RestaurantHero from "../../images/HomeNew/restaurant_hero.webp";
import CalendarIcon2 from "../../images/HomeNew/calendar-icon.png";

const WebinarModal = lazy(() => import("./WebinarModal"));
const PreRazorpay = lazy(() => import("../WebinarRazorPay/PreRazorpay"));
const FooterWebinar = lazy(() => import("../Common/Footer/footerWebinar"));
const SuccessModal = lazy(() => import("./SuccessModel"));
const CoverWebinarSection = lazy(() =>
  import("./cover-webinar-section-restaurant")
);
const MeetExpertSection = lazy(() => import("./meet-expert-section"));
const WebinarProofSection = lazy(() => import("./webinar-media-section"));
const JoinWebinarSection = lazy(() =>
  import("./join-webinar-section-restaurant")
);
const WebinarFaqSection = lazy(() => import("./webinar-faq-section"));
const YourWebinarSection = lazy(() => import("./your-webinar-section-restaurant"));
const JoinCommunitySection = lazy(() =>
  import("./Join-community-section-restaurant")
);
const TestimonialSection = lazy(() => import("./testimonial-section-restaurant"));

const DEFAULT_WHATSAPP_URL =
  "https://chat.whatsapp.com/CSt5Uq9KBmj96FmaJYYYfk?mode=ems_copy_t";

function DeferredSection({ children, rootMargin = "250px 0px" }) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    if (isVisible) return undefined;
    if (!sectionRef.current) return undefined;

    if (!("IntersectionObserver" in window)) {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [isVisible, rootMargin]);

  return <div ref={sectionRef}>{isVisible ? children : null}</div>;
}

function formatWebinarDate(value) {
  const parsedDate = value ? new Date(value) : new Date();
  if (Number.isNaN(parsedDate.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(parsedDate);
}
// import { Helmet } from "react-helmet";
function Webinar(props) {
  const isFromLead = props.isFromLead;
  const pixelId = props?.pixelId;
  const isWebinarRS9 = props.isWebinarRS9;
  // console.log("ISWEBINAR9 : ", isWebinarRS9, isFromLead);

  const isFromLeadWithForm = props.isFromLeadWithForm;
  const [isOpenModal, setOpenModal] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showRazorpay, setShowRazorpay] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [minutes, setMinutes] = useState(15);
  const [seconds, setSeconds] = useState(0);

  const [userData, setUserData] = useState({
    email: "",
    phone: "",
    city: "",
    status: "inactive",
    sellerName: "",
    storeName: "",
    webinarDate: "",
    paymentRazorPayId: "",
    paymentOrderId: "",
    paymentStatus: "unpaid",
    isFromLeadWithForm: false,
  });

  const [settingData, setSettingData] = useState({});
  const [Utms, setUtms] = useState({});
  const whatsappUrl = settingData?.webinarWhatsappUrl || DEFAULT_WHATSAPP_URL;
  const webinarDateLabel = formatWebinarDate(settingData?.webinarDate);

  const getSetting = async () => {
    const response = await API.get(FETCH_SETTINGS);
    if (response?.data?.success) {
      setSettingData(response?.data?.result);
    } else {
      notify("error", response?.data?.message);
    }
  };

  function closeModal() {
    setOpenModal(false);
  }
  function getUTMParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_term: params.get("utm_term"),
      utm_content: params.get("utm_content"),
    };
  }
  const saveUtms = async (utms) => {
    try {
      await fetch(`${process.env.REACT_APP_ONDC_APP_KIKO_API_V2}/save-utms`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          desktop: "true",
        },
        body: JSON.stringify(utms),
      });
    } catch (error) {}
  };

  useEffect(() => {
    getSetting();
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV === "development") return undefined;

    let isCancelled = false;
    const requestIdle =
      window.requestIdleCallback || ((callback) => setTimeout(callback, 1200));
    const cancelIdle = window.cancelIdleCallback || clearTimeout;

    const runTracking = async () => {
      if (isCancelled) return;

      try {
        const utms = getUTMParams();
        setUtms(utms);
        void saveUtms(utms);

        if (pixelId) {
          const module = await import("./pixel");
          if (!isCancelled) {
            module.initializeFacebookPixel(pixelId);
          }
        }

        if (!isCancelled && window.fbq) {
          window.fbq("track", "PageView", utms);
        }
      } catch (error) {
        if (!isCancelled && window.fbq) {
          window.fbq("track", "PageView");
        }
      }

      if (!document.getElementById("clarity-script")) {
        const script = document.createElement("script");
        script.id = "clarity-script";
        script.async = true;
        script.src = "https://www.clarity.ms/tag/sr3m95np08";
        document.head.appendChild(script);
      }
    };

    const idleId = requestIdle(() => {
      void runTracking();
    });

    return () => {
      isCancelled = true;
      cancelIdle(idleId);
    };
  }, [pixelId]);

  // useEffect(() => {
  //   let timer;
  //   if (minutes > 0 || seconds > 0) {
  //     timer = setInterval(() => {
  //       if (seconds > 0) {
  //         setSeconds((prev) => prev - 1);
  //       } else if (minutes > 0) {
  //         setMinutes((prev) => prev - 1);
  //         setSeconds(59);
  //       }
  //     }, 1000);
  //   }

  //   return () => clearInterval(timer); // cleanup
  // }, [minutes, seconds]);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prevSec) => {
        if (prevSec > 0) return prevSec - 1;
        else {
          setMinutes((prevMin) => (prevMin > 0 ? prevMin - 1 : 0));
          return 59;
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleChange = (e) => {
    // console.log('eeee')
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePaymentResponse = async (payload) => {
    try {
      if (payload?.paymentResponse?.razorpay_payment_id && payload?.success) {
        // setShowRazorpay(false);
        const user = JSON.parse(localStorage.getItem("userDetails")) || {};
        user.paymentRazorPayId = payload?.paymentResponse?.razorpay_payment_id;
        user.paymentOrderId = payload?.paymentResponse?.razorpay_order_id;
        user.paymentStatus = "paid";
        user.status = "active";
        localStorage.setItem("userDetails", JSON.stringify(user));
        const response = await API.post(ADD_WEBINAR_PARTICIPANT, user);
        if (response?.data?.success) {
          console.log(response?.data, 'data')
          localStorage.setItem(
            "userDetails",
            JSON.stringify(response?.data?.result)
          );
          import("./pixel").then((module) => {
            module.initializeFacebookPixel(pixelId, {
              em: response?.data?.result?.email,
              fn: response?.data?.result?.sellerName,
              ln: response?.data?.result?.storeName,
              ph: response?.data?.result?.phone,
            });
          });
          setUserData(response?.data?.result);
          closeModal();
          setShowRazorpay(false);
          setIsSuccess(true);
        } else {
          notify("error", "Something went wrong!");
        }
        // notify("success", "Subscription Activated");
      } else {
        setShowRazorpay(false);
        notify("error", payload?.message);
      }
    } catch (error) { }
  };

  const onsubmit = async (e) => {
    e.preventDefault();
    // console.log("Form submitted:", userData);
    try {
      if (!userData?.sellerName) {
        notify("error", "Please Enter seller name!");
        return;
      }
      if (!userData?.city) {
        notify("error", "Please Enter City / Town / Village");
        return;
      }
      if (
        !userData?.email ||
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)
      ) {
        notify("error", "Please enter a valid email address!");
        return;
      }
      if (userData?.phone?.length < 10 || userData?.phone?.length > 10) {
        notify("error", "Please Enter valid number!");
        return;
      }
      if (!userData?.storeName) {
        notify("error", "Please Enter store name!");
        return;
      }
      const body = {
        ...userData,
        webinarDate: settingData?.webinarDate ?? "",
        isFromLeadWithForm: isFromLeadWithForm ? isFromLeadWithForm : false,
        utm_source: Utms?.utm_source ?? "",
        utm_medium: Utms?.utm_medium ?? "",
        utm_campaign: Utms?.utm_campaign ?? "",
        utm_content: Utms?.utm_content ?? "",
      };

      setDisabled(true);
      const response = await API.post(ADD_WEBINAR_PARTICIPANT, body);
      if (response?.data?.success) {
        // try {
        localStorage.setItem(
          "userDetails",
          JSON.stringify(response?.data?.result)
        );
        // } catch (err) {
        //   console.error("Failed to set localStorage:", err);
        // }
        setUserData({
          email: "",
          phone: "",
          city: "",
          status: "inactive",
          sellerName: "",
          storeName: "",
          paymentRazorPayId: "",
          paymentOrderId: "",
          paymentStatus: "unpaid",
        });
        closeModal();
        if (isFromLeadWithForm) {
          setIsSuccess(true);
        } else {
          setShowRazorpay(true);
        }
      } else {
        notify("error", "Something went wrong!");
      }
      setDisabled(false);
    } catch (error) {
      console.log("error: ====>>>>> ", error);

      handleError(error);
    }
  };

  return (
    <>
      {/* {isFromLeadWithForm && (
        <Helmet>
          <title>Free Restaurant Registration | Sell on Own Website</title>
          <meta
            name="description"
            content=" Start getting website orders within 24 hours. Best solution for Restaurants. Easy 2 minute registration. Best Customer Support. Free Ecommerce Website."
          />
        </Helmet>
      )} */}
      <div className="webinar-container">
        <section className="webinar-hero-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="webinar-hero-inner">
                  <div className="webinar-hero-img">
                    <img src={RestaurantHero} alt="Restaurant hero banner" width={680} height={453} fetchpriority="high" />
                  </div>
                  <div>
                    <div className="webinar-hero-title">
                      Stop Paying <span className="yellow-text">50%</span>{" "}
                      Commission! Get{" "}
                      <span className="yellow-text">
                        {" "}
                        Your Own Online Restaurant
                      </span>{" "}
                      {isFromLeadWithForm ? "Website." : "on ONDC."}
                    </div>

                    <div className="webinar-hero-text">
                      {isFromLeadWithForm ? (
                        <>
                        Join our live webinar designed for restaurant owners and understand how ONDC can help you reach new customers and grow online orders.

                        </>
                      ) : (
                        "Join our live webinar designed for restaurant owners and understand how ONDC can help you reach new customers and grow online orders."
                      )}
                    </div>
                    <div style={{fontWeight:"bold"}} className="webinar-hero-text">
                    Secure your seat for just ₹9.
                    </div>
                    <div className="webinar-date-time">
                      <img
                        className="calendar-icon"
                        src={CalendarIcon2}
                        alt="Calendar"
                        width={24}
                        height={24}
                      />
                      <div className="webinar-date">
                        {webinarDateLabel}
                        <span className="divider">|</span>
                        3:00 PM
                      </div>
                    </div>
                    <button
                      className="register-webinar-btn"
                      onClick={() =>
                        isFromLead
                          ? window.open(
                              whatsappUrl,
                              "_blank"
                            )
                          : setOpenModal(true)
                      }
                    >
                      {isFromLead || isFromLeadWithForm
                        ? "JOIN WEBINAR WHATSAPP GROUP"
                        : "Register for webinar"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <OnlineSellingSection /> */}
        {/* <WebinarBlogSection /> */}
        <DeferredSection>
          <Suspense fallback={null}>
            <CoverWebinarSection />
          </Suspense>
        </DeferredSection>
        <DeferredSection>
          <Suspense fallback={null}>
            <JoinCommunitySection />
          </Suspense>
        </DeferredSection>
        <DeferredSection>
          <Suspense fallback={null}>
            <YourWebinarSection />
          </Suspense>
        </DeferredSection>
        <DeferredSection>
          <Suspense fallback={null}>
            <TestimonialSection />
          </Suspense>
        </DeferredSection>
        <DeferredSection>
          <Suspense fallback={null}>
            <MeetExpertSection />
          </Suspense>
        </DeferredSection>
        <DeferredSection>
          <Suspense fallback={null}>
            <WebinarProofSection />
          </Suspense>
        </DeferredSection>
        <DeferredSection>
          <Suspense fallback={null}>
            <JoinWebinarSection
              setOpenModal={setOpenModal}
              isFromLead={isFromLead}
              isFromLeadWithForm={isFromLeadWithForm}
              whatsAppUrl={whatsappUrl}
            />
          </Suspense>
        </DeferredSection>
        <DeferredSection>
          <Suspense fallback={null}>
            <WebinarFaqSection />
          </Suspense>
        </DeferredSection>
      </div>
      {showRazorpay && (
        <Modal
          isOpen={showRazorpay}
          onRequestClose={() => {
            setShowRazorpay(false);
          }}
        >
          <div className="subscribe-modal-payment">
            <Suspense fallback={null}>
              <PreRazorpay
                amount={isWebinarRS9 ? 9 : 49}
                onPaymentResponse={handlePaymentResponse}
                setOpenPreRazorpayModal={setShowRazorpay}
                {...props}
              />
            </Suspense>
          </div>
        </Modal>
      )}
      {isOpenModal && (
        <Suspense fallback={null}>
          <WebinarModal
            handleChange={handleChange}
            disabled={disabled}
            userData={userData}
            onsubmit={onsubmit}
            onClose={() => setOpenModal(false)}
            isFromLeadWithForm={isFromLeadWithForm}
            isWebinarRS9={isWebinarRS9}
          />
        </Suspense>
      )}
      {isSuccess && (
        <Suspense fallback={null}>
          <SuccessModal
            whatsAppUrl={whatsappUrl}
            amount={isWebinarRS9 ? 9 : 49}
            onClose={() => {
              setUserData({
                email: "",
                phone: "",
                city: "",
                status: "inactive",
                sellerName: "",
                storeName: "",
                paymentRazorPayId: "",
                paymentOrderId: "",
                paymentStatus: "unpaid",
              });
              setIsSuccess(false);
            }}
            pixelId={pixelId}
            isFromLeadWithForm={isFromLeadWithForm}
          // {...props}
          />
        </Suspense>
      )}
      <DeferredSection>
        <Suspense fallback={null}>
          <FooterWebinar />
        </Suspense>
      </DeferredSection>
      <div className="webinar-remaining-time-container">
        <div className="webinar-remaining-time-container-inner">
          {isFromLead || isFromLeadWithForm ? (
            <div className="webinar-remaining-time-title title-thanks">
              <span>Thank You For Registration</span>
              <br />
              <p>Click on the button to join our webinar whatsapp group</p>
            </div>
          ) : (
            <div className="webinar-remaining-time-title">
              Hurry! Only Few Seats Left For The <span>Webinar</span>
            </div>
          )}
          <div className="webinar-remaining-time-right">
            {!isFromLead && !isFromLeadWithForm && (
              <div className="webinar-remaining-time">
                <div className="remaining-time-items">
                  {minutes}
                  <div className="remaining-time-label">Minutes</div>
                </div>
                <div className="remaining-time-divider">:</div>
                <div className="remaining-time-items">
                  {seconds}
                  <div className="remaining-time-label">Seconds</div>
                </div>
              </div>
            )}
            <button
              className="register-webinar-btn"
              onClick={() =>
                isFromLead
                  ? window.open(
                      whatsappUrl,
                      "_blank"
                    )
                  : setOpenModal(true)
              }
            >
              {isFromLead || isFromLeadWithForm
                ? "JOIN WEBINAR WHATSAPP GROUP"
                : "Register for webinar"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Webinar;
